import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, Grid, Tooltip, Chip } from '@mui/material';
import axios from '../axios';

const Presenze = ({ idCorso, idAlunno }) => {
    const [presenze, setPresenze] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem('token');

        const fetchPresenze = async () => {
            try {
                const response = await axios.post('datahandler/corso-alunno-presenze', {
                    idCorso,
                    idAlunno,
                    token: token
                });
                const presenzeFiltrate = response.data.filter(item => item.mostralezione == "1");

                setPresenze(presenzeFiltrate);

            } catch (error) {
                console.error('Error fetching presenze:', error);
            }
        };

        fetchPresenze();
    }, [idCorso, idAlunno]);

    return (
        <Box mt={2} mb={1}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#555', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ width: 4, height: 16, bgcolor: '#4caf50', borderRadius: 4 }} />
                Presenze Lezioni
            </Typography>
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 0.8,
                p: 1.2,
                background: 'rgba(255, 255, 255, 0.3)',
                borderRadius: '12px',
                border: '1px solid rgba(255, 255, 255, 0.5)',
                backdropFilter: 'blur(8px)',
                boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.4)'
            }}>
                {presenze.length > 0 ? (
                    presenze.map((presenza, index) => {
                        let color = '#bdbdbd'; // Grigio (N.S.)
                        let tooltip = 'Presenza non salvata';
                        let textColor = '#444';

                        if (presenza.presente === '1') {
                            color = '#c8e6c9'; // Verde chiaro
                            textColor = '#1b5e20';
                            tooltip = 'DinoAlunno presente';
                        } else if (presenza.presente === '0') {
                            color = '#ffcdd2'; // Rosso chiaro
                            textColor = '#b71c1c';
                            tooltip = 'DinoAlunno assente';
                        }

                        return (
                            <Tooltip key={index} title={tooltip} arrow placement="top">
                                <Chip
                                    label={presenza.datalezione != null ? presenza.datalezione : "Lezione " + presenza.progr_lezione}
                                    size="small"
                                    sx={{
                                        height: 24,
                                        fontSize: '0.7rem',
                                        fontWeight: 700,
                                        bgcolor: color,
                                        color: textColor,
                                        border: '1px solid rgba(0,0,0,0.05)',
                                        borderRadius: '6px',
                                        transition: 'all 0.2s ease',
                                        '& .MuiChip-label': { px: 1 },
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                            bgcolor: color,
                                            filter: 'brightness(0.95)'
                                        },
                                    }}
                                />
                            </Tooltip>
                        );
                    })
                ) : (
                    <Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic', pl: 1 }}>
                        Nessuna presenza registrata.
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default Presenze;
